window.addEventListener('DOMContentLoaded', (event) => {
  var swiper = new Swiper('.hero-mySwiper', {
    slidesPerView:1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    
  });

  $(document).on('click', '.hero-mySwiper .navigate-link', function() {
    swiper.slideNext();
  });

  $(document).on('click', '.hero-mySwiper .back-button', function() {
    swiper.slidePrev();
  });


  var mySwiper = new Swiper('.gallery-slider', {
    spaceBetween: 1,
    slidesPerView: 3,
    centeredSlides: true,
    spaceBetween: 0,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
     breakpoints: {
      300: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      600: {
        slidesPerView: 3,
        spaceBetween: 27
      }
    }
  });
});